import data from './schools.json'
let schools = [
  {
    type: 'Feature',
    id: 'IEO Normal Superior Farallones Cali',
    properties: {
      name: 'IEO Normal Superior Farallones Cali',
      dir: 'Kr 22 2 65 Oeste',
      tel: '5587300 - 5577936 - 3901010',
      email: 'ie_nsfarallones@cali.gov.co',
      projects: {
        prj01: {
          level: 'Robusto',
          indicators: [
            {
              ind: 'XVIII. El proyecto está siendo implementado de acuerdo con lo planeado.',
              res: 'La relación entre planeación e implementación se encuentra en estado de DESARROLLO; debido a que, se encuentra un desarrollo y proceso de avance en la aplicación de  las actividades según lo planeado. Existen resultados parciales de los procesos. <br> - Se realizaron visitas que permitieron establecer que faltaba en los PPP para la resolución de sus necesidades.<br> - Avance en diversas actividades de alistamiento para el montaje de los diferentes proyectos productivos como: aprobación de la infografía del proceso, visita a los lugares de implementación, generación de listado de insumos y delimitación de las actividades de los PPP.<br> - Avance en diversas actividades de alistamiento para el montaje de los diferentes proyectos productivos como: aprobación de la infografía del proceso, visita a los lugares de implementación, generación de listado de insumos y delimitación de las actividades de los PPP.',
              color: 'incipiente'
            },
            {
              ind: 'XIX. Valoración de los participantes de las actividades del programa.',
              res: '- Se valora que el aporte del proyecto se relaciona con el Incremento de participación por parte de actores como padres de familia',
              color: 'desarrollo'
            },
            {
              ind: 'XX. Cambios en el diseño y la ejecución del proyecto como resultado de la participación desde los actores',
              res: 'Para la IEO  muchos de los cambios proyectados en espacios como el fortalecimiento de los PPP, la transversalización curricular, la puesta en marcha de la propuesta y la dotación de insumos es un tema que apenas inicia. Lo anterior se le atribuye al poco tiempo que ha tenido la ejecución del proyecto o problemas de infraestructura.',
              color: 'intermedio'
            }
          ]
        },
        prj02:  {
          level: 'Iniciación',
          indicators: [
            {
              ind: 'XVIII. El proyecto está siendo implementado de acuerdo con lo planeado.',
              res: 'La relación entre planeación e implementación se encuentra en estado de DESARROLLO; debido a que, se encuentra un desarrollo y proceso de avance en la aplicación de  las actividades según lo planeado. Existen resultados parciales de los procesos. - Se realizaron visitas que permitieron establecer que faltaba en los PPP para la resolución de sus necesidades. - Avance en diversas actividades de alistamiento para el montaje de los diferentes proyectos productivos como: aprobación de la infografía del proceso, visita a los lugares de implementación, generación de listado de insumos y delimitación de las actividades de los PPP. - Avance en diversas actividades de alistamiento para el montaje de los diferentes proyectos productivos como: aprobación de la infografía del proceso, visita a los lugares de implementación, generación de listado de insumos y delimitación de las actividades de los PPP.',
              meta: 6.0,
              AnMeta: 2019,
              color: 'intermedio'
            },
            {
              ind: 'XIX. Valoración de los participantes de las actividades del programa.',
              res: '- Se valora que el aporte del proyecto se relaciona con el Incremento de participación por parte de actores como padres de familia',
              meta: 9.0,
              AnMeta: 2019,
              color: 'maduracion'
            },
            {
              ind: 'XX. Cambios en el diseño y la ejecución del proyecto como resultado de la participación desde los actores',
              res: 'Para la IEO  muchos de los cambios proyectados en espacios como el fortalecimiento de los PPP, la transversalización curricular, la puesta en marcha de la propuesta y la dotación de insumos es un tema que apenas inicia. Lo anterior se le atribuye al poco tiempo que ha tenido la ejecución del proyecto o problemas de infraestructura.',
              meta: 16.0,
              AnMeta: 2019,
              color: 'robusto'
            }
          ]
        }
      }
    },
    geometry: {
      type: 'Point',
      coordinates: [-76.543385, 3.442410]
    }
  }
]
schools = data
export default schools
